import React, { Component } from 'react'
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

//#region  modules
import { actions as appActions, selectors as appSelectors } from "../../modules/appModule"

import { createTheme, ThemeProvider } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import { COLOR, PATH } from "../../modules/constants"

import history from '../../services/history'

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR.BRAND.STD,
      contrastText: COLOR.WHITE,
    },
    secondary: {
      main: COLOR.GOOD,
    },
  },
});

class IdleLogoutModal extends Component {

  render() {
    // console.log('IdleLogoutModal this.props:', this.props)
    const { idleLoggedOut, open, timeToLogout } = this.props
    const title = idleLoggedOut
      ? "You were automatically logged out due to no activity"
      : "You are about to be logged out"

    const onClickClose = () => {
      // console.log('onClose : this.props.idleLoggedOut:', idleLoggedOut)
      this.props.app.setIdleLoggedOut(false)
      // this.props.onClose()
    }

    const onClickLogin = () => {
      this.props.app.setIdleLoggedOut(false)
      history.push(`/${PATH.LOGIN}`)
    }

    return (
      <ThemeProvider theme={theme}>
        <Dialog
          open={true}
          onClose={onClickClose}
          maxWidth="sm"
          fullWidth
          sx={{ minHeight: "30%" }}
        >
          <DialogTitle sx={{ color: COLOR.WARN }}>
            {title}
          </DialogTitle>
          {
            !idleLoggedOut && <DialogContent>
              {`If no activity is detected, you will be logged out in ${timeToLogout + 1} seconds.`}
            </DialogContent>
          }
          {/* <DialogContent>{content2}</DialogContent> */}

          {
            idleLoggedOut && <DialogActions>
              <Button onClick={onClickLogin} color="primary" variant="contained">
                Login
              </Button>
              <Button onClick={onClickClose} color="primary" variant="contained">
                Close
              </Button>
            </DialogActions>
          }
        </Dialog >
      </ThemeProvider>
    )
  }
}

const mapStateToProps = state => {
  const { app, common, search, user } = state
  return {
    timeToLogout: appSelectors.getTimeToLogout(app),
    idleLoggedOut: app.idleLoggedOut,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
  }
}
// export default IdleLogoutModal

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IdleLogoutModal))
export default connect(mapStateToProps, mapDispatchToProps)((withRouter(IdleLogoutModal)))


